export const kaminValidityNames: Record<string, string> = {
  Valid: "معتبر باقی ماند", Invalid: "نامعتبر شد", NoOpenOrders: "سفارش باز کمین وجود نداشت", NotChecked: "اعتبارسنجی اجرا نشد",
};
export const kaminCancellationNames: Record<string, string> = {
  NotRequired: "لغو لازم نبود", Cancelled: "لغو تأیید شد", Closed: "سفارش‌های هدف بسته شدند",
  Pending: "فلگ لغو زده شد؛ لغو هنوز تأیید نشده", Failed: "لغو خطا داشت؛ فلگ لغو حفظ شد",
};
export const kaminPlacementNames: Record<string, string> = {
  Placed: "سفارش‌گذاری شد", NotPlaced: "سفارش‌گذاری نشد", NotSent: "درخواست ثبت شد؛ ارسال نشد",
  Rejected: "درخواست رد شد؛ سفارش‌گذاری نشد", Partial: "بخشی از سفارش‌گذاری تأیید شد",
  AwaitingConfirmation: "ارسال تلاش شد؛ تأیید کارگزاری دریافت نشده",
};
